import Avatar, { ConfigProvider } from 'react-avatar';
import React from 'react';

interface UserAvatarProps {	
	color?: string;
	name: string;
	round?: boolean;
	size?: string;
	status?: 'online' | 'offline';
	showStatus?: boolean;
}

const UserAvatar: React.FC<UserAvatarProps> = (props) => {
	const { color, name, round, size, status, showStatus } = props;

	return (
		<div className='relative'>
			<Avatar color='#F4EBFF' className='font-semibold' fgColor='#7F56D9' name={name} round={round} size={size || '40'} />
			{showStatus && <span
				className={`w-3 h-3 absolute inline-block rounded-full bottom-2 right-1 ${
					status === 'online' ? 'bg-green-500' : 'bg-red-500'
				}`}
			/>}
		</div>
	);
};

export default UserAvatar; 